import { createFileRoute, Outlet } from '@tanstack/react-router'

import { SettingsLayout } from '@/components/settings/settings-layout'

/** Every settings screen under one "Settings" header and its tabs. */
export const Route = createFileRoute('/_app/_org/settings')({
  component: () => (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  ),
})
